'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState, useRef } from 'react';

const getBodyClassForPath = (pathname: string): string[] => {
  if (pathname.startsWith('/journal-news')) return ['bg-flora', 'journals'];
  if (pathname.startsWith('/contact')) return ['contact-footer'];
  // if (pathname.startsWith('/process')) return ['process'];
  if (pathname.startsWith('/projects/') && pathname.split('/').length === 3)
    return ['bg-linen', 'projects', 'projects-details'];
  if (pathname === '/projects') return ['bg-linen', 'projects'];
  if (pathname === '/' || pathname.startsWith('/home')) return ['bg-linen', 'home'];
  return [];
};

export default function ThemeTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const [visible, setVisible] = useState(true);
  const [transitionKey, setTransitionKey] = useState(pathname);
  const appliedClassesRef = useRef<string[]>([]);

  useEffect(() => {
    setVisible(false); // Trigger fade-out

    const timeout = setTimeout(() => {
      // Remove previous theme classes
      appliedClassesRef.current.forEach((cls) => document.body.classList.remove(cls));
      appliedClassesRef.current = [];

      // Add transition gap class
      document.body.classList.add('theme-transition-gap');

      // Add new theme classes after short delay
      const classAddTimeout = setTimeout(() => {
        document.body.classList.remove('theme-transition-gap');
        const classes = getBodyClassForPath(pathname);
        document.body.classList.add(...classes);
        appliedClassesRef.current = classes;

        setTransitionKey(pathname);
        setVisible(true); // Trigger fade-in
      }, 100); // gap duration

      return () => clearTimeout(classAddTimeout);
    }, 400); // fade-out duration

    return () => clearTimeout(timeout);
  }, [pathname]);

  return (
    <div key={transitionKey} className={`fadeContainer ${visible ? 'fadeIn' : 'fadeOut'}`}>
      {children}
    </div>
  );
}